import { makeStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles({
  claimAmount: {
    color: red.A700,
  },
});

export default useStyles;
